import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=A%20dramatic%20aerial%20view%20of%20a%20massive%20modern%20sports%20stadium%20at%20night%20with%20floodlights%20illuminating%20the%20pitch%2C%20packed%20crowd%2C%20electric%20atmosphere%2C%20fireworks%20bursting%20above%2C%20golden%20and%20warm%20tones%2C%20cinematic%20sports%20photography%2C%20grand%20scale%2C%20spectacular%20vista&width=1800&height=700&seq=hero-stadium-bg&orientation=landscape)`,
        }}
      >
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 md:px-6 w-full">
        <div className="max-w-4xl mx-auto w-full">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/90 text-white text-sm font-medium mb-6">
            <span className="w-2 h-2 rounded-full bg-white animate-pulse"></span>
            <span>5场赛事正在直播中</span>
          </div>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4">
            每一刻都是<span className="text-primary-300">高燃</span>瞬间
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            开体育在线为您提供全球顶级体育赛事实时直播、深度资讯与竞技数据。
            足球、篮球、综合格斗、电竞——不错过任何精彩时刻。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/football"
              className="px-8 py-3.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm transition-all whitespace-nowrap cursor-pointer"
            >
              观看直播
              <i className="ri-play-circle-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 rounded-lg bg-white/15 hover:bg-white/25 text-white font-semibold text-sm backdrop-blur-sm transition-all whitespace-nowrap cursor-pointer border border-white/20"
            >
              了解更多
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}